import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchUserProfileBlogMockData } from "../Utils/UserProfileFetchBlogData"
import POProfileImageUploader from "../Utils/ProfileImageUploader";
import "../Styles/common-styles.css"
import PageProfileModal from "../../../common/PopupPages/PageProfile";

const BloggingProfile = ({userId, profileId}) => {
      const [blogs, setBlogs] = useState(null);
      const [ProfileImage, setProfileImage] = useState(null);
      const [showPopup, setShowPopup] = useState(false); 
      const [renderOperation, setRenderOperation] = useState(null);
      
      useEffect(() => {
        const loadProfileData = async () => {
          const profileData = await fetchUserProfileBlogMockData(profileId);
          
          if (profileData) {
            setProfileImage(profileData.profileImage);
            setBlogs(profileData.blogs);
          }
        };
    
        // setShowPopup(true);
      
        if (profileId) {
          loadProfileData();
        }
      }, [profileId]);

      useEffect(() => {
        if (ProfileImage) {
          console.log("Updated profile image state:", ProfileImage);
        }
      }, [ProfileImage]);
    
      const handleUserClick = (operationType, userId) => {
        setShowPopup(false);
        setRenderOperation({
          operationType,
          data: { userId },
        });
      };

      const handleCloseModal = () => {
        setRenderOperation(null);
      };

    return (
        <div className="up-profile-container">
            <div className="overlay-grid-layout" style={{width: "100%", height: "1000px", display: "flex", flexDirection: "column"}}>
                <div className="up-blog-grid-upper" style={{width: "100%", height: "20%" }}>
                <POProfileImageUploader
                    userId={userId}
                    profileImage={ProfileImage}
                    profileName={profileId}
                    operationType="blogging"
                />       
                </div>
                <div className="up-blog-grid-lower" style={{width: "100%", height: "80%" }}>
                    {blogs?.length === 0 ? (
                        <p className="text-black">No Group found</p>
                    ) : (
                        blogs?.map((blog) => (
                            <div key={blog.blogId} 
                                className="up-profile-card" 
                                style={{display: "flex", flexDirection: "column"}}
                                onClick={() => handleUserClick("open", userId)}
                            >
                                <div className="ug-profile">
                                    <img src={blog.thumbnailUrl} alt="Group" className="up-image"/>
                                    <div className="up-details">
                                        <h4 className="up-text-label" >{blog.title}</h4>
                                    </div>            
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            {['open'].includes(renderOperation?.operationType) && (
      <div
        className="modal-overlay"
        style={{
          position: "fixed", // or "absolute" if you want relative to a parent
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000, // must be above all other components
        }}
      >
        <div
          style={{
            background: "#1a1a1a",
            padding: "20px",
            borderRadius: "12px",
            minWidth: "300px",
            maxWidth: "90%",
            maxHeight: "90%",
            overflowY: "auto",
          }}
        >          
          <PageProfileModal
            userId={renderOperation.data.userId}
            operationType={renderOperation.operationType}
            onClose={handleCloseModal}
          />
        </div>
      </div>
      )}
        </div>
    );
};

export default BloggingProfile;